import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import cooperativeShopItem from "./cooperativeShopItem";

export interface cooperativeInterface{
    id:number,
    icon?:string,
    bankName?:string,
    name:string,
    explain:string,
    isOnly:boolean,
    videoFlag:boolean,
    param:{[p:string]:any}
}

export interface cooperativeBreedInterface{
    id:number,
    name:string,
    explain:string,
    isOnly:boolean,
    videoFlag:boolean,
    param:{[p:string]:any}
}

export interface cooperativeMap{
    [id:string]:cooperativeInterface;
}

export interface cooperativeShopInterface{
    id:number,
    name:string,
    explain:string,
    isOnly:boolean,
    videoFlag:boolean,
    vaildHour:number,
    param:{[p:string]:any}
}

export interface cooperativeShopMap{
    [id:string]:cooperativeShopInterface
}

export interface cooperativeShopSaveItem{
    //id
    id:number,
    //开启时间
    openTime:number
}

let bankCooperativeAry:cooperativeInterface[] = null;

let breedCooperativeAry:cooperativeInterface[] = null;

let bankCooperativeMap:cooperativeMap = null;

let breedCooperativeMap:cooperativeMap = null;

let shopCooperativeAry:cooperativeShopInterface[] = null;

let shopCooperativeMap:cooperativeShopMap = null;

export function getBankCooperativeAry(){
    if(!bankCooperativeAry){
        bankCooperativeAry = [
            {id:1,bankName:"凤凰银行",name:"扶贫贷",icon:"凤凰银行",isOnly:true,videoFlag:false,explain:"借款金额：1W元 还款周期：30天\n每日还款：500",param:{money:10000,weChatLink:"34"}},
            {id:2,bankName:"绿叶信用社",name:"无赖贷",icon:"绿叶信用社",isOnly:true,videoFlag:false,explain:"借款金额：5W元 还款周期：30天\n每日还款：3000",param:{money:40000,weChatLink:"35"}},
            {id:3,bankName:"摇钱树银行",name:"阎王贷",icon:"摇钱树银行",isOnly:false,videoFlag:true,explain:"借款金额：50W 还款周期：25天\n每日还款：2W",param:{money:500000,accountInfo:{title : "阎王贷还款",desc : "成功贷款@！日利率@ \n限期@还清，每日还款@",paramsArray:["500000元","0%","25日","20000"],totalFee : 500000,needPayDays : 25,hasPayDays : 0,}}},
            {id:4,bankName:"富豪银行",name:"生死贷",icon:"富豪银行",isOnly:false,videoFlag:true,explain:"借款金额：100W元 还款周期：20天\n每日还款：5W",param:{money:1000000,accountInfo:{title : "生死贷还款",desc : "成功贷款@！日利率@ \n限期@还清，每日还款@",paramsArray:["1000000元","0%","20日","50000"],totalFee : 1000000,needPayDays : 20,hasPayDays : 0,}}}
        ]
    }
    return bankCooperativeAry;
}

export function getBreedCooperativeAry(){
    if(!breedCooperativeAry){
        breedCooperativeAry = [
            {id:1,name:"鸡场养殖资格证",isOnly:true,videoFlag:true,explain:"开鸡场必备哦！",param:{}}
        ]
    }
    return breedCooperativeAry;
}

export function getBankCooperativeMap(){
    if(!bankCooperativeMap){
        bankCooperativeMap = <cooperativeMap>{};
        let ary = getBankCooperativeAry();
        for(let i of ary){
            bankCooperativeMap[i.id] = i;
        }
    }
    return bankCooperativeMap;
}

export function getBreedCooperativeMap(){
    if(!breedCooperativeMap){
        breedCooperativeMap = <cooperativeMap>{};
        let ary = getBreedCooperativeAry();
        for(let i of ary){
            breedCooperativeMap[i.id] = i;
        }
    }
    return breedCooperativeMap;
}

export function getCooperativeShopAry(){
    if(!shopCooperativeAry){
        shopCooperativeAry = [
            //bundle 是budle名字 prefabPath
            {id:0,name:"蛋糕店",isOnly:true,videoFlag:true,vaildHour:72,explain:"开蛋糕店必备哦！",param:{openPrefab:{bundle:BUNDLE_SMALL_NAME.setUpShopGameBundle,prefabPath:"prefab/swingPlateShop"}}}
        ]
    }
    return shopCooperativeAry;
}

export function getCooperativeShopMap(){
    if(!shopCooperativeMap){
        shopCooperativeMap = <cooperativeShopMap>{};
        let ary = getCooperativeShopAry();
        for(let data of ary){
            shopCooperativeMap[data.id] = data;
        }
    }
    return shopCooperativeMap;
}

